<div class="background-image-container">
    <div class="banner-image">
        <div class="clip-wrapper">
            <div class="left-clip"></div>
        </div>

        <div class="clip-wrapper right-wrapper">
            <div class="right-clip"></div>
        </div>
    </div>
</div>

<div class="icon-column">
    <img *ngIf="!mobileService.isMobile" src="/build/assets/images/woodcoin.svg" alt="Woodcoins Icon">
    <img *ngIf="mobileService.isMobile" src="/build/assets/images/logo.svg" alt="Zimmerer-Treffpunkt Icon">
</div>

<div class="text-column-mobile">
    <div class="text-column-mobile-half-width">
        <p class="top-text" [innerHTML]="mobileTopText"></p>
    </div>

    <div class="text-column-mobile-full-width">
        <p class="top-text-last-line"> {{mobileTopTextLastLine}}</p>
    </div>

    <div class="text-column-mobile-half-width">
        <p class="bottom-text" [innerHTML]="mobileBottomText"></p>
    </div>
</div>

<div class="text-column-tablet">
    <p class="top-text">{{ desktopAndTabletTopText }}</p>
    <p class="bottom-text">{{ tabletBottomText }}</p>
</div>

<div class="text-column-desktop">
    <div class="action-headline">{{ desktopAndTabletTopText }}</div>
    <div class="bottom-text" [innerHTML]="desktopBottomText"></div>
</div>

<div class="button-column">
    <button class="blue-button mobileGrowBtn" (click)="dialogService.loginRegistrationDialog('registration')"
        *ngIf="!userService.isLoggedIn; else loggedInButton">
        Jetzt Mitglied werden
    </button>

    <ng-template #loggedInButton>
        <create-entry-button [hasPlusIcon]="false"></create-entry-button>
    </ng-template>
</div>